import { makeStyles, tokens } from '@fluentui/react-components';
import { Link } from 'react-router-dom';

import { PageHeader } from '@/design-system';
import { spacing } from '@/theme/tokens';

import { ElevationHistory } from './components/ElevationHistory';
import { SubmitElevationForm } from './components/SubmitElevationForm';

const useStyles = makeStyles({
  stack: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.l,
  },
  historyFooter: {
    marginTop: spacing.s,
    fontSize: tokens.fontSizeBase200,
  },
  historyLink: {
    color: tokens.colorBrandForegroundLink,
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
    },
    ':focus-visible': {
      outline: `2px solid ${tokens.colorStrokeFocus2}`,
      outlineOffset: '2px',
      textDecoration: 'underline',
    },
  },
});

/**
 * Requester view: submit + recent activity. The approver-only
 * `PendingDecisions` surface lives at `/elevation/approvals` (see
 * ApprovalsPage), reachable from the gated "Approvals" item in the left nav.
 * Splitting them keeps the requester landing page focused.
 *
 * The landing table shows a 30-day window. The wider history view lives at
 * `/elevation/history` (HistoryPage.tsx) so an operator scanning the
 * landing page sees what's recent without scrolling through stale rows.
 */
export function ElevationPage() {
  const classes = useStyles();
  return (
    <div>
      <PageHeader
        title="Elevated permissions"
        description="Request, audit, and revoke time-bound Azure role assignments. 4-hour default. 30-day recent view; wider 2-year history view (currently up to 1000 rows). Approvers: open the Approvals tab in the left nav."
      />
      <div className={classes.stack}>
        <SubmitElevationForm />
        <ElevationHistory />
        <div className={classes.historyFooter}>
          <Link to="/elevation/history" className={classes.historyLink}>
            View 2-year history
          </Link>
        </div>
      </div>
    </div>
  );
}
